import React from 'react';
import { Link } from 'react-router-dom';


const TouristSecurity = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top tourist-security-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">Tourist Security</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Tourist Security</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Tourist Security</strong></h2>
                        <h3 className="sub-heading-page sub-heading-m-t-15"><strong>Tourist Protection Service in India for Foreigners and Expats</strong></h3>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            India offers an excellent travel experience which is second to none and arguably cannot be witnessed anywhere else in the world. India is a country with rich heritage and diverse culture wherein every few hundred kilometers language and culture changes. Right from North to South to East to West there is something store for everyone.
                        </p>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            But with growing security concerns in recent times, visitors are afraid of travelling to India. In such a scenario, we step in to secure your travel and keep you safe all the time, no matter where you are travelling in India. Our Personal Protection Officer in India will be with you 24/7 to protect and guide you in your journey. To make you feel safer, we can offer a 24/7 real time tracking solution where a small portable GPS tracking device shall be with you and your movement can be monitored by us for security purpose.
                        </p>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            Our head office is located in India, which is the safest city in India. But you may require a close protection officer, if you are visiting outside the city to places such as Goa, Delhi, Taj Mahal Agra, Kerala, etc. You may like to hire Personal Protection Officer in India, if you are visiting populated areas and slums to keep notorious people and street vendors at bay.
                        </p>

                        <h3 className="sub-heading-page sub-heading-m-t-15 "><strong>PSO Cum Driver Service</strong></h3>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            Personal Security Officer (PSO) can work as a driver to enable you to save cost on hiring two individuals and also occupying space in a vehicle. Our PSO cum Driver service in India comes with a valid driving license. PSO cum Driver is physically fit and mentally alert person with local knowledge. He is a skilled driver to take you wherever you desire. You can hire PSO cum Driver Service in India for a trip, short term basis or long term basis. For hiring PSO cum Driver on short term basis, you need to inform us at least a day in advance to enable us make the required arrangement.
                        </p>
                        <h3 className="sub-heading-page sub-heading-m-b-15 "><strong>Why us?</strong></h3>

                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Full fledge Security Company with PSARA license (issued by Police/Home Department) which requires adherence to various act, rules and regulation unlike other event security companies which only caters to short term security solution.</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  You can choose from male or female security officer</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  We provide round the clock support, guidance and tracking from our centralised location</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  We can help you with local knowledge of places to visit and precautions to take</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Now shop without being tricked or scammed</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Feel protected round the clock</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Our Close Protection Officer will work as a guide, language translator, negotiator and above all protector to make your journey to India a truly memorable one.</li>

                        </ul>


                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>How to hire?</strong></h3>
                        <p className="octo-para">
                            The process is very easy. You can book the service simply over a call or an email. Give us your requirement and get quotation from us within two hours. Once you approve, our team would take care of the rest.
                        </p>
                    </div>
                </div>
            </section>




        </>
    )
}

export default TouristSecurity;
